var JobCandidatesCompareController = /** @class */ (function () {
    /*@ngInject*/
    function JobCandidatesCompareController($rootScope, $timeout, jobService, userRoleService, jobMatchActionsService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.jobService = jobService;
        this.userRoleService = userRoleService;
        this.jobMatchActionsService = jobMatchActionsService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    JobCandidatesCompareController.prototype.$onInit = function () {
        $('.modal').css("overflow-y", "scroll");
        this.isSuperUserOr4dot5Admin = this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin();
        this.isJobMatchPanelOpen = true;
        this.isEducationPanelOpen = true;
        this.isExperiencePanelOpen = true;
        this.isTechnicalSkillsPanelOpen = true;
        this.isOperationalSkillsPanelOpen = true;
        this.isSoftSkillsPanelOpen = true;
        this.isOtherSkillsPanelOpen = true;
        this.isCertificationsPanelOpen = true;
        this.isCompensationPanelOpen = true;
        this.isSalaryPanelOpen = true;
        this.isSponsorshipsPanelOpen = true;
        this.isRelocationPanelOpen = true;
        this.isAdditionalInformationPanelOpen = true;
        this.togglePanelsLabel = 'Collapse All';
        this.isAllPanelsOpen = true;
        //variables
        this.comparisonData = [];
        this.panelClasses = ['education-assets', 'experience-assets', 'tech-assets', 'operational-assets', 'soft-assets', 'certification-assets', 'other-assets', 'compensation-assets', 'salary-assets', 'sponsorship-assets', 'relocation-assets'];
        this.panelBootStrapColumnWidthClass = 'col-xs-3';
        this.companyId = this.$rootScope.userDetails.company.companyId;
        //flags
        this.loadingFlag = true;
        this.panelBootStrapColumnWidthClass = this.candidateIds.split(',').length == '2' ? 'col-xs-4' : 'col-xs-3';
        // get the job candidates comparison
        this.multipleCandidatesSingleJobComparison();
    };
    JobCandidatesCompareController.prototype.togglePanels = function () {
        var _this = this;
        this.isAllPanelsOpen = !this.isAllPanelsOpen;
        this.togglePanelsLabel = this.isAllPanelsOpen ? 'Collapse All' : 'Expand All';
        this.isJobMatchPanelOpen = this.isAllPanelsOpen;
        this.isEducationPanelOpen = this.isAllPanelsOpen;
        this.isExperiencePanelOpen = this.isAllPanelsOpen;
        this.isTechnicalSkillsPanelOpen = this.isAllPanelsOpen;
        this.isOperationalSkillsPanelOpen = this.isAllPanelsOpen;
        this.isSoftSkillsPanelOpen = this.isAllPanelsOpen;
        this.isOtherSkillsPanelOpen = this.isAllPanelsOpen;
        this.isCertificationsPanelOpen = this.isAllPanelsOpen;
        this.isCompensationPanelOpen = this.isAllPanelsOpen;
        this.isSalaryPanelOpen = this.isAllPanelsOpen;
        this.isSponsorshipsPanelOpen = this.isAllPanelsOpen;
        this.isRelocationPanelOpen = this.isAllPanelsOpen;
        this.isAdditionalInformationPanelOpen = this.isAllPanelsOpen;
        this.workflowSteps.forEach(function (step) {
            step.isOpen = _this.isAllPanelsOpen;
        });
    };
    JobCandidatesCompareController.prototype.multipleCandidatesSingleJobComparison = function () {
        var _this = this;
        this.loadingFlag = true;
        this.jobService.multipleCandidatesSingleJobComparison(this.jobId, this.candidateIds, this.companyId, function (data) {
            _this.comparisonData = data.multipleCandidateSingleJobComparisonDetails;
            _this.workflowSteps = _this._getMassagedWorkflowSteps(data.workFlowSteps);
            _this._massageComparisonData();
            _this.loadingFlag = false;
            _this._setHeightsOfPanels();
            _this.initializeSliders();
        }, function (error) {
            _this.loadingFlag = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    JobCandidatesCompareController.prototype._getMassagedWorkflowSteps = function (workflowStepsData) {
        var workflowSteps = [];
        for (var stepKey in workflowStepsData) {
            workflowSteps.push({ step: workflowStepsData[stepKey], isOpen: true });
        }
        return workflowSteps;
    };
    JobCandidatesCompareController.prototype._massageComparisonData = function () {
        var _this = this;
        angular.forEach(this.comparisonData, function (comparison, key) {
            angular.forEach(comparison.educationComparisons, function (experience, expKey) {
                if (experience.candidateInstituteName === null || experience.candidateInstituteName === "") {
                    experience.candidateInstituteName = "'Unknown'";
                }
            });
            comparison.educationComparisonsGrouped = [];
            if (comparison.educationComparisons) {
                var groupedDegrees = _this.groupBy(comparison.educationComparisons, 'jobDegreeName');
                var _loop_1 = function (degree) {
                    var institutes = groupedDegrees[degree];
                    var institutesText = "";
                    institutes.forEach(function (institution, key) {
                        institutesText = "<span> " + institutesText + " " + institution.candidateDegreeName + " at " + institution.candidateInstituteName + "</span><br>";
                    });
                    var institute = groupedDegrees[degree][0];
                    institute.text = institutesText;
                    comparison.educationComparisonsGrouped.push(institute);
                };
                for (var degree in groupedDegrees) {
                    _loop_1(degree);
                }
            }
            if (comparison.latestEducationDto) {
                if (comparison.latestEducationDto.candidateInstituteName === null || comparison.latestEducationDto.candidateInstituteName === "") {
                    comparison.latestEducationDto.candidateInstituteName = "'Unknown'";
                }
            }
            angular.forEach(comparison.experienceComparisons, function (experience, expKey) {
                if (experience.company === null || experience.company === "") {
                    experience.company = "'Unknown'";
                }
            });
            comparison.jobMatchScore = Math.floor(parseFloat(comparison.jobMatchScore));
            if (comparison.workflowStepsComparisons) {
                if (comparison.workflowStepsComparisons.techAssessmentComparisons && comparison.workflowStepsComparisons.techAssessmentComparisons.score) {
                    comparison.workflowStepsComparisons.techAssessmentComparisons.score = Math.floor(parseFloat(comparison.workflowStepsComparisons.techAssessmentComparisons.score));
                }
                if (comparison.workflowStepsComparisons.valueAssessmentComparisons && comparison.workflowStepsComparisons.valueAssessmentComparisons.score) {
                    comparison.workflowStepsComparisons.valueAssessmentComparisons.score = Math.floor(parseFloat(comparison.workflowStepsComparisons.valueAssessmentComparisons.score));
                }
            }
            comparison.technicalSkillCounts = {
                matched: 0,
                unMatched: 0,
                additional: 0,
                almost: 0
            };
            comparison.operationalSkillCounts = {
                matched: 0,
                unMatched: 0,
                additional: 0,
                almost: 0
            };
            comparison.softSkillCounts = {
                matched: 0,
                unMatched: 0,
                additional: 0,
                almost: 0
            };
            comparison.otherSkillCounts = {
                additional: 0
            };
            angular.forEach(comparison.technicalSkillComparisons, function (skill, expKey) {
                if (skill.status === 'MATCH') {
                    comparison.technicalSkillCounts.matched++;
                }
                else if (skill.status === 'UN_MATCH') {
                    comparison.technicalSkillCounts.unMatched++;
                }
                else if (skill.status === 'ADDITIONAL') {
                    comparison.technicalSkillCounts.additional++;
                }
                else if (skill.status === 'ALMOST') {
                    comparison.technicalSkillCounts.almost++;
                }
            });
            angular.forEach(comparison.operationalSkillComparisons, function (skill, expKey) {
                if (skill.status === 'MATCH') {
                    comparison.operationalSkillCounts.matched++;
                }
                else if (skill.status === 'UN_MATCH') {
                    comparison.operationalSkillCounts.unMatched++;
                }
                else if (skill.status === 'ADDITIONAL') {
                    comparison.operationalSkillCounts.additional++;
                }
                else if (skill.status === 'ALMOST') {
                    comparison.operationalSkillCounts.almost++;
                }
            });
            angular.forEach(comparison.softSkillComparisons, function (skill, expKey) {
                if (skill.status === 'MATCH') {
                    comparison.softSkillCounts.matched++;
                }
                else if (skill.status === 'UN_MATCH') {
                    comparison.softSkillCounts.unMatched++;
                }
                else if (skill.status === 'ADDITIONAL') {
                    comparison.softSkillCounts.additional++;
                }
                else if (skill.status === 'ALMOST') {
                    comparison.softSkillCounts.almost++;
                }
            });
            angular.forEach(comparison.otherComparisons, function (skill, expKey) {
                if (skill.status === 'ADDITIONAL') {
                    comparison.otherSkillCounts.additional++;
                }
            });
        });
        this.jobDetails = angular.copy(this.comparisonData[0]);
    };
    JobCandidatesCompareController.prototype.groupBy = function (objectArray, property) {
        return objectArray.reduce(function (acc, obj) {
            var key = obj[property];
            if (!acc[key]) {
                acc[key] = [];
            }
            // Add object to list for given key's value
            acc[key].push(obj);
            return acc;
        }, {});
    };
    JobCandidatesCompareController.prototype._setHeightsOfPanels = function () {
        var _this = this;
        // make height of each division equal so that the compare view is easier to look at horizontally.
        this.$timeout(function () {
            angular.forEach(_this.panelClasses, function (val, key) {
                // get each panel / category type
                var panelsArray = $("." + val);
                // get an array of lengths of 'li' items within each panel
                var lengths = panelsArray.map(function (key, panel) {
                    return $(panel).children('li').length;
                }).get();
                // get the maximum number of 'li' per panel
                var maxLength = Math.max.apply(null, lengths);
                for (var i = 0; i < maxLength; i++) {
                    // for each of the list of 'li' s
                    var maxHeight = 0;
                    // find the maximum height among the 'li' s in the horizontal row
                    angular.forEach(panelsArray, function (val, key) {
                        // in each of the panels / categories, find the max height of the li
                        var liItem = $(val).children('li')[i];
                        if (!_.isUndefined(liItem) && $(liItem).height() > maxHeight) {
                            maxHeight = $(liItem).height();
                        }
                    });
                    // for each li, set it to the max height
                    angular.forEach(panelsArray, function (val, key) {
                        var liItem = $(val).children('li')[i];
                        if (!_.isUndefined(liItem)) {
                            $(liItem).height(maxHeight);
                            // $(liItem).css('margin-bottom','5px');
                            $(liItem).css('margin', '0px -18px 3px -18px');
                            $(liItem).css('padding-left', '40px');
                            $(liItem).css('padding-right', '4px');
                            // for every even entry, set the background as very light grey
                            if (i % 2 == 0) {
                                $(liItem).css('background', '#efefef');
                            }
                        }
                    });
                }
                // after the horizontal li's have been adjusted to be same height, set the panels to all have same height
                // this is to account for the extra 'li' s some panels might have
                var heights = panelsArray.map(function (key, panel) {
                    return $(panel).height();
                }).get();
                var maxHeight = Math.max.apply(null, heights);
                $("." + val).height(maxHeight);
            });
        }, 200);
    };
    JobCandidatesCompareController.prototype.isComparisonEmpty = function (comparison) {
        return angular.equals(comparison, {});
    };
    JobCandidatesCompareController.prototype.getReport = function (jobMatchId, assessmentType, isSectionalReport, reportUrl, testInvitationId) {
        this.jobMatchActionsService.getReport(jobMatchId, assessmentType, isSectionalReport, reportUrl, testInvitationId, 'job-candidates-compare');
    };
    JobCandidatesCompareController.prototype.viewFeedback = function (feedbackType, label, candidateId, jobMatchId) {
        var feedbackDetails = {
            candidateId: candidateId,
            jobId: this.jobId,
            jobMatchId: jobMatchId,
            feedbackType: feedbackType,
            label: label,
            context: 'jobCandidatesCompare'
        };
        this.jobMatchActionsService.openFeedbackModal(feedbackDetails);
    };
    JobCandidatesCompareController.prototype.initializeSliders = function () {
        var _this = this;
        this.$timeout(function () {
            $("div[class='overall-qn-slider']").each(function (i, obj) {
                var jobMatchId = obj.id.split('__')[1].split('_')[0];
                var questionId = obj.id.split('__')[1].split('_')[1];
                var labelId = "overall-qn-rating__" + jobMatchId + '_' + questionId;
                $(obj).noUiSlider({
                    range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                    slide: function () {
                        var val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                    },
                    set: function () {
                        var val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                    }
                });
                // set the initial value
                var candidate = _this.comparisonData.find(function (candidate) { return candidate.jobMatchId === jobMatchId; });
                var feedback = candidate.workflowStepsComparisons.recruiterScreeningComparisons.feedBacks ? candidate.workflowStepsComparisons.recruiterScreeningComparisons.feedBacks[questionId] : { rating: 0 };
                $(obj).val(feedback.rating, true);
            });
            $("div[class='overall-qn-slider_ps']").each(function (i, obj) {
                var jobMatchId = obj.id.split('__')[1].split('_')[0];
                var questionId = obj.id.split('__')[1].split('_')[1];
                var labelId = "overall-qn-rating__" + jobMatchId + '_' + questionId + '_ps';
                ;
                $(obj).noUiSlider({
                    range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                    slide: function () {
                        var val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                    },
                    set: function () {
                        var val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                    }
                });
                // set the initial value
                var candidate = _this.comparisonData.find(function (candidate) { return candidate.jobMatchId === jobMatchId; });
                var feedback = candidate.workflowStepsComparisons.phoneScreenComparisons.feedbacks ? candidate.workflowStepsComparisons.phoneScreenComparisons.feedbacks[questionId] : { rating: 0 };
                $(obj).val(feedback.rating, true);
            });
            $("div[class='overall-qn-slider_in']").each(function (i, obj) {
                var jobMatchId = obj.id.split('__')[1].split('_')[0];
                var questionId = obj.id.split('__')[1].split('_')[1];
                var labelId = "overall-qn-rating__" + jobMatchId + '_' + questionId + '_in';
                $(obj).noUiSlider({
                    range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                    slide: function () {
                        var val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                    },
                    set: function () {
                        var val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                    }
                });
                // set the initial value
                var candidate = _this.comparisonData.find(function (candidate) { return candidate.jobMatchId === jobMatchId; });
                var feedback = candidate.workflowStepsComparisons.interviewComparisons.feedbacks ? candidate.workflowStepsComparisons.interviewComparisons.feedbacks[questionId] : { rating: 0 };
                $(obj).val(feedback.rating, true);
            });
        }, 200);
    };
    return JobCandidatesCompareController;
}());
JobCandidatesCompareController.$inject = ['$rootScope', '$timeout', 'jobService', 'userRoleService', 'jobMatchActionsService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './job-candidates-compare.html';
import * as TEMPLATE from 'raw-loader!./job-candidates-compare.html';
export var JobCandidatesCompareComponent = {
    selector: 'jobCandidatesCompare',
    component: {
        bindings: {
            jobId: '@',
            candidateIds: '@'
        },
        controller: JobCandidatesCompareController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/jobCandidatesCompare/job-candidates-compare.html'
    }
};
//# sourceMappingURL=job-candidates-compare.component.js.map